var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmallPostcard = function SvgSmallPostcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.954,
    d: "M20.2 10.333h-4V7.667h4zM3.666 3.667h2.933M3.666 6.333h5.6M11.934 3.667v6.666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.954,
    d: "M13.933 13h8.933V1H1v12z"
  })));
};
export default SvgSmallPostcard;